
import React from 'react'
import { Grid, Column, actionCell, iconCell } from 'components/grid'
import { localized } from 'decorators'

export default localized(({ dataSource, metadata, onRowClick, localize, actionProps, persistor }) => {
  return (
    <Grid
        dataSource={dataSource}
        onRowClick={onRowClick}
        pageSizes={[5, 10, 20, 50, 100]}
        persistor={persistor}>
        <Column field='id' title={localize('common.id')} width='70px' filterable={false} />
        <Column field='name' title={localize('common.name')} cell={iconCell({ icon: metadata.icon })} width='350px' />
        <Column field='vintage' title={localize('wines.vintage')} filter='numeric' width='220px' />
        <Column field='grapeName' title={localize('wines.grape')} width='270px' />
        <Column field='producerName' title={localize('wines.producer')} width='270px' />
        <Column field='regionName' title={localize('wines.region')} width='270px' />
        <Column field='countryName' title={localize('wines.country')} width='270px' />
        <Column field='districtName' title={localize('wines.district')} width='270px' />
        <Column field='subdistrictName' title={localize('wines.subdistrict')} width='270px' />
        <Column cell={actionCell({ actionProps })} width='100px' filterable={false} sortable={false} />
    </Grid>
  )
})
